<template>
  <div style="width: 100%;height: 100%;background: #fff">
      <LayoutHeader :route="'notice'+str"/>
      <div class="banner-box">
          <img src="../assets/home/notice-banner.png" alt="">
          <div class="text">{{ str == '1' ? '通知公告' : '政策公告'}}</div>
      </div>
      <div class="breadBox">
        <a-breadcrumb>
          <span>
            当前位置：
          </span>
          <a-breadcrumb-item style="cursor: pointer;" @click="this.$router.push('/')">首页</a-breadcrumb-item>
          <a-breadcrumb-item>{{ str == '1' ? '通知公告' : '政策公告'}}</a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <div class="list-container">
          <div class="left">
              <div :class="str == '1' ? 'item-active':''" @click="strChange('1')" class="item">通知公告 <img src="@/assets/home/right-jiantou.png" alt=""></div>
              <div :class="str == '2' ? 'item-active':''" @click="strChange('2')" class="item ">政策公告 <img src="@/assets/home/right-jiantou.png" alt=""></div>
          </div>
          <div class="right">
              <div class="title">
                  <img src="../assets/home/notice-icon2.png" alt="">
                  {{ str == '1' ? '通知公告': '政策公告' }}</div>
              <div class="con-box" v-if="str == '1'">
                  <div class="item" @click="goDetail(item.id, 1)" v-for="(item,index) in scrollNoticeData"  :key="index">
                      <div class="item-1">
                          <div class="item-left">
                              <div class="name">
                                  <img src="@/assets/home/xing.png" alt="">
                                  {{ item.title }}</div>
<!--                              <img class="huolizhi" v-for="i in item.fire" :key="i" src="@/assets/home/huolizhi.png" alt="">-->
                          </div>
                          <div class="time" v-if="!item.show">{{ item.publishTime.substring(0,10) }}</div>
                      </div>
                      <div class="item-2" v-if="item.show">
                          <span v-html="item.content"></span>
                          <div class="item-2-1">
                              <div class="faburen">{{ item.publisher }}</div>
                              <div class="faburen">{{ item.publishTime }}</div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="con-box" v-if="str == '2'">
                  <div class="item" @click="goDetail(item.id, 2)" v-for="(item,index) in noticeData"  :key="index">
                      <div class="item-1">
                          <div class="item-left">
                              <div class="name">
                                  <img src="@/assets/home/xing.png" alt="">
                                  {{ item.title }}</div>
                              <!--                              <img class="huolizhi" v-for="i in item.fire" :key="i" src="@/assets/home/huolizhi.png" alt="">-->
                          </div>
                          <div class="time" v-if="!item.show">{{ item.publishTime.substring(0,10) }}</div>
                      </div>
                      <div class="item-2" v-if="item.show">
                          <span v-html="item.content"></span>
                          <div class="item-2-1">
                              <div class="faburen">{{ item.publisher }}</div>
                              <div class="faburen">{{ item.publishTime }}</div>
                          </div>
                      </div>
                  </div>
              </div>
              <a-pagination :current="pagination.pageNum" @change="paginationChange" :total="pagination.total" show-less-items />
          </div>
      </div>
    <LayoutFooter />
  </div>
</template>

<script>
import { dictMixin } from "@/mixins";
import { login_mp } from "@/api/adminService";
import { ls } from "@/utils/util"
import { enterpriseOperatingIncome } from "@/api/integral";
import { sys_admin, file_service, noticeInfoHome } from "@/api/adminService";
import { noticeInfo, getBannerInfo, getWebInfo } from "@/api/homeService";
import { platformName } from "@/config/platformConfig";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import LayoutHeader from '@/layout/layoutPage/header/LayoutHeaderNew2';
import { getDistMixin, listMixin } from "@/mixins";
export default {
  name: "index",
  components: {
    LayoutFooter,
      LayoutHeader
  },
  mixins: [dictMixin, getDistMixin, listMixin],
  data() {
    return {
        searchValue:'',
      pagination:{
            pageSize:10,
          pageNum:1,
          total:0
      },
      noticeData: [],
      scrollNoticeData: [],
      fourObj: {},
      user: {},
      getDetailNoteParam: null,
      operatingIncomeScale: null,
      platformName,
      getAuditStatus: null,
      visible: false,
      getDateId: null,
      formState: {
        user: undefined,
      },
      policyNotice: {},
      bannerData: [],
      webSiteInfo: {},
      linkData: [],

      queryParam: {},
      listUrl: noticeInfo.pageList,
      current: 1,
      pageSize: 10,
      str: null,
      // selectOption: [
      // 	{ label: '种子期(0（含）—100万元)', value: 1 },//seed
      // 	{ label: '初创期(100（含）—500万元)', value: 2 },//newly
      // 	{ label: '成长期(500（含）—2000万元)', value: 3 },//growth
      // 	{ label: '成熟期(2000（含）以上万元)', value: 4 }, //maturation
      // ],
    }
  },
  // computed: {
  //   listUrl() {
  //     return this.$route.query.type == 1 ? noticeInfoHome.pageList : noticeInfo.pageList
  //   }
  // },
  methods: {
      paginationChange(e){
          this.pagination.pageNum = e
          if (this.str == 1) {
              this.getNoticeDownInfo()
          } else {
              this.getNoticeInfo()
          }
      },
      strChange(e){
          this.pagination.pageNum=1
          this.str = e
          if (this.str == 1) {
              this.getNoticeDownInfo()
          } else {
              this.getNoticeInfo()
          }
      },
    logout() {
      let self = this;

      self.$ls.clear();
      self.$store.commit('setMenuData', []);
      self.$router.replace('/');

      location.reload();
    },
    onLogout() {
      let self = this;
      self.$confirm({
        title: '确认要退出登录?',
        content: '',
        onOk() {
          self.postAction({
            url: login_mp.saveLog,
            params: { logAppCategoryEnum: "LOGOUT" }
          }).then(res => {
            console.log(res)
            self.getAction({
              url: login_mp.logout,
              params: { access_token: ls.get("token") || "" },
              isValid: false
            }).then(() => {
              self.$notification['success']({
                message: '退出成功',
                style: {
                  fontWeight: '600',
                },
              });
            })
          })


          setTimeout(() => {
            self.logout();
          }, 2000)
        },
        onCancel() {
        },
      });
    },
    goMorePolicy() {
      this.$router.push({
        path: '/notice',
        // query: { type: "资讯公告", activeKey: 2 }
      })
    },
    goDetail(id,type) {
      this.$router.push({
        path: "/noticeDetail",
        query: { id: id,type: type }
      })
    },
    getUserInfo() {
      this.getAction({
        url: sys_admin.userInfor
      }).then(res => {
        sessionStorage.setItem("roleCode", res.roleCode.split(','));
      })
    },
    getNoticeInfo() {
      this.getAction({
        url: noticeInfo.pageList,
        params: this.pagination
      }).then(res => {
        this.noticeData = res.records
        this.pagination.total = res.total
      })
    },
    getNoticeDownInfo() {
      this.getAction({
        url: noticeInfoHome.pageList,
        params: this.pagination
      }).then(res => {
        this.scrollNoticeData = res.records
          this.pagination.total = res.total
          console.log()
      })
    },
    goHttp(url) {
      window.open(url, '_bank')
    },
    goMore(url, str) {
      this.$router.push({ path: url, query: { id: str } })
    },
    goMoreNotice(url, str) {
      console.log('url: ', url, str)
      this.$router.push({ path: url, query: { ...str } })
    },
    getDetail() {
      this.getAction({
        url: enterpriseOperatingIncome.detail,
        params: {
          id: this.getDateId.id,
        },
        returnMsg: true,
      }).then((res) => {
        this.getDetailNoteParam = res.data
        this.operatingIncomeScale = res.data.operatingIncomeScale
        this.getAuditStatus = res.data.auditStatus
      });
    },
    getDate() {
      this.getAction({
        url: enterpriseOperatingIncome.getDate,
        // params: { id: id },
        returnMsg: true,
      }).then((res) => {
        this.getDateId = res.data
        // auditStatus
      });
    },
    islogin() {
      if (ls.get('token') && ls.get("refresh_token")) {
        if (ls.get("roleCode").includes('company')) {
          this.goMore('/sys/companyInfo')
        } else if (ls.get("roleCode").includes('technicalManager')) {
          this.goMore('/sys/technology/person');
        } else if (ls.get("roleCode").includes('serviceOrganization')) {
          this.goMore('/sys/innovation/organization/index');
        } else if (ls.get("roleCode").includes('investorManager')) {
          this.goMore('/finance/investorInformation');
        } else if (ls.get("roleCode").includes('investmentMechanism')) {
          this.goMore('/finance/investmentOrganizationInformation');
        } else if (ls.get("roleCode").includes('financialAdviser')) {
          this.goMore('/finance/financialAdvisorInformation');
        } else {
          this.goMore('/sys/userInfo')
        }
      } else {
        this.goMore('/login', 'user')
      }
    },
    getBannerList() {
      this.getAction({
        url: getBannerInfo.pageList,
        params: { type: 'home' }
      }).then(res => {
        this.bannerData = res.records.reverse()
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    getWebInfo() {
      this.getAction({
        url: getWebInfo.detail,
        params: { id: 1 }
      }).then(res => {
        this.webSiteInfo = res
      })
    },
  },
  mounted() {
    this.str = this.$route.query.type
    this.getWebInfo()
    this.getBannerList()
      // if(this.$route.query.type == 1){
      //     this.listUrl = noticeInfoHome.pageList
      // }else{
      //     this.listUrl =  noticeInfo.pageList
      // }
    // this.getDate()
    if (this.$route.query.type == 1) {
      this.getNoticeDownInfo()
    } else {
      this.getNoticeInfo()
    }
    if (ls.get('token') && ls.get("refresh_token")) {
      this.user.userName = this.$ls.get('userName')
      this.user.phoneNumber = this.$ls.get('phoneNumber')
    }
  },
  watch:{
    '$route.query.type':function(newV) {
      this.str = newV
      this.getWebInfo()
      this.getBannerList()
      if (newV == 1) {
        this.getNoticeDownInfo()
      } else {
        this.getNoticeInfo()
      }
      if (ls.get('token') && ls.get("refresh_token")) {
        this.user.userName = this.$ls.get('userName')
        this.user.phoneNumber = this.$ls.get('phoneNumber')
      }
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .ant-pagination{
    display: flex;
    justify-content: center;
    margin-top:36px !important;
}
::v-deep .ant-pagination-item-active{
    background: #0059b5;
    border:none;
}
::v-deep .ant-pagination-item-active a{
    color: #fff;
}
::v-deep .ant-pagination-item:hover{
    background: #0059b5;
    border:none;
    a{
        color: #fff;
    }
}
.breadBox{
    width: 1200px;
    margin:0 auto;
    padding:20px 0;
    border-bottom: 1px solid #DEDEDE;
}
.list-container{
    width: 1200px;
    margin:0 auto;
    padding:20px 0;
    display: flex;
    justify-content: space-between;
    .left{
        background: url("../assets/home/notice-img1.png");
        background-size: 100% 100%;
        width: 300px;
        height: 598px;
        color:#fff;
        padding-top:100px;
        .item{
            padding:15px 40px 26px 40px;
            font-weight: bold;
            font-size: 20px;
            color: #FFFFFF;
            cursor: pointer;
            img{
                 width: 22px;
                 height: 22px;
                 float: right;
                 margin-top:4px;
            }
        }
        .item-active{
            background: url("../assets/home/notice-icon1.png");
            background-size: cover;
            padding:15px 40px 26px 40px;
        }
    }
    .right{
        width: 70%;
        .title{
            font-weight: 400;
            font-size: 36px;
            color: #333333;
            line-height: 50px;
            img{
                width: 26px;
            }
        }
        .con-box{
            .item:hover .name{
                color: #0059b5 !important;
                font-weight: bold;
            }
            .item{
                margin: 20px 0;
                cursor: pointer;
                .item-1{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 18px;
                    .item-left{
                        display: flex;
                        align-items: center;
                        width: 80%;
                        .huolizhi{
                            width: 12px;
                            height: 16px;
                            margin:0 3px;
                        }
                        .name{
                            color: #333333;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            word-break: break-all;
                            white-space: nowrap;
                            margin-right: 10px;
                        }
                    }
                    .time{
                        color: #999999;
                    }
                }
                .item-2{
                    border-bottom: 1px solid #dedede;
                    span{
                        font-size: 16px;
                        color: #666666;
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        word-break: break-all;
                        margin:20px 0 10px 0;
                    }
                    .item-2-1{
                        display: flex;
                        justify-content: space-between;
                        font-size: 16px;
                        color: #999;
                        margin:0 0 20px 0;
                    }
                }
            }
        }
    }
}
.banner-box{
    position: relative;
    img{
        width: 100%;
        height: 240px;
        object-fit: cover;
    }
    .text{
        position: absolute;
        top: 60px;
        width: 1200px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        left:50%;
        transform: translateX(-50%);
        font-weight: 400;
        font-size: 36px;
        color: #FFFFFF;
        line-height: 50px;
        &::before{
            content:'';
            display: block;
            width: 70px;
            height: 3px;
            background: #fff;
            position: absolute;
            top:60px;
        }
    }
}

</style>
